import React, { useContext, useMemo } from "react";
import { string, oneOf, array, bool, func } from "prop-types";
import { SelectDropdown } from "./";
import { useTextDomainContext } from "@/app/providers";
import { useDocumentTypeArray } from "@/hooks";

export const DocumentTypeDropdown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const documentType = useDocumentTypeArray();

  //#region useMemo
  const options = useMemo(() => {
    return documentType;
  }, [documentType]);

  const componentLabel = useMemo(() => {
    return props.componentLabel || gettext("Document Type");
  }, [gettext, props.componentLabel]);
  //#endregion useMemo

  const handleOnChange = (e: any) => {
    if (typeof props.onChange === "function") {
      props.onChange(e);
    }
  };

  return (
    <>
      <SelectDropdown
        required={true}
        options={
          options as unknown as import("@/types/Dropdown.types").DropdownOption[]
        }
        componentLabel={componentLabel}
        showAll={props.showAll}
        defaultValue={props.defaultValue}
        onChange={handleOnChange}
        visualStyle="autoComplete"
      />
    </>
  );
};

DocumentTypeDropdown.propTypes = {
  componentLabel: string,
  defaultValue: oneOf([string, array]),
  showAll: bool,
  onChange: func,
};
